mutation ($id: ID!, $name: String!,  $iconId: ID,  $colorId: ID, $studentIds: [ID]) {
  grade_level_update (id: $id, gradeLevel: { name: $name, iconId: $iconId, colorId: $colorId, studentIds: $studentIds }) {
    canCurrentDelete
    name
    color {
      id
      name
      displayName
    }
    icon {
      id
      name
      displayName
    }
    id
    order
    orderDenominator
    orderNumerator
    studentList(sortBy: ALPHA, sortDirection: ASC, page: 1) {
      list {
        id
        first
        last
        positivity
        mostRecentCommunication
        communicationCount
        gradeLevel {
          id
          name
          order
        }
      }
      count
      remaining
      pageSize
    }
  }
}
